import Request from "../../services/Request";
import ResponseChecker from "../../services/ResponseChecker";
import NotiMessage from "../../services/NotiMessage";

const notiMessage = new NotiMessage("success");

// URL //
const eachUrl = "da/getEach?";
const allUrl = "da/get?";
const storeUrl = "da/store";
const updateUrl = "da/update?";
const deleteUrl = "da/delete?";

const state = {
  das: [],
  da: {},
};
const getters = {};
const mutations = {
  SET_DAS(state, payload) {
    state.das = payload.data.data;
  },
  SET_DA(state, payload) {
    state.da = payload.data.data;
  },
  ADD_DA(state, payload) {
    state.das.push(payload.data.data);
  },
  REMOVE_DA(state, payload) {
    const das = state.pas.filter((item) => item.id != payload.id);
    state.das = [...das];
  },
};

const actions = {
  async getDAs({ commit }) {
    const response = await Request.get_data(allUrl);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) commit("SET_DAS", response);
  },
  async getDA({ commit }, id) {
    const response = await Request.get_data(eachUrl, {
      column: "id",
      value: id,
    });
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) commit("SET_DA", response);
  },
  async createDA({ commit }, payload) {
    const response = await Request.post_data(storeUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("ADD_DA", response);
      notiMessage.displayNotiMsg("Saved Success");
      return true;
    }
    return false;
  },
  async updateDA(context, payload) {
    const response = await Request.post_data(updateUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg("Updated Success");
      return true;
    }
    return false;
  },
  async deleteDA({ commit }, payload) {
    const response = await Request.post_data(deleteUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("REMOVE_DA", payload);
      notiMessage.displayNotiMsg("Deleted Success");
      return true;
    }
    return false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
